
import { Component, Vue, Prop } from "vue-property-decorator";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import { SMUser } from "@/store";
import { TCase_Dependant_Applicant, TCase_Main_Applicant } from "@/models/cases";

const ICONS = {
  alert: "alert-circle",
};

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class OnExpertReviewCandidateCosAndSwWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Object }) readonly mainApplicant?: TCase_Main_Applicant;
  @Prop({ type: Object }) readonly dependantApplicant?: TCase_Dependant_Applicant;

  icons = ICONS;

  get computedProps() {
    const { jobTitle, name, listType } = this;

    return {
      title: this.$tc(`title`),
      jobTitle,
      name,
      listType,
    };
  }

  getText(target) {
    const role = SMUser.user?.role;

    if (!role) return "";

    const path = `${role}.${target}`;

    return this.$t(path) || "";
  }

  get text() {
    return this.getText("text");
  }

  get subtext() {
    return this.getText("subtext");
  }
}
